import { Typography } from "@mui/material"
import BillingTabComponent from "./component/BillingTabComponent"
import PrintProvider from "../../context/PrintProvider/PrintProvider"

const BillingComponent = () => {
  return (
     <PrintProvider>
        <div className="px-2 pt-4 pb-2">
      <Typography fontWeight={600} sx={(theme)=>({color:theme.palette.primary.main,px:1,py:.5})}>Patient-care - Billing</Typography>
      <BillingTabComponent/>
      </div>
     </PrintProvider>
  )
}

export default BillingComponent
